import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Grid, Box } from '@mui/material';
import AssignmentIcon from '@mui/icons-material/Assignment';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { Card, ExpandingText, IconButton, Typography } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';
import { copyToClipboard } from 'utils/functions';
import { LogMessageContainer, LogRequestDetailsContainer } from './ServiceLogStyles';
import { DetatchedAccordion } from 'components/common/SurfaceStyles';

const ServiceRequestComponent = ({ request, onDownloadFile }) => {
  const { t } = useTranslation();

  const formatDate = useCallback(
    value => {
      const result = t('DATE_FORMAT', {
        date: { value, format: 'DD.MM.YYYY HH:mm:ss' }
      });
      return result;
    },
    [t]
  );

  return (
    <DetatchedAccordion
      title={
        <Typography variant='subtitle2' fontWeight='bold'>
          <Box>
            {t('Offer.Edit.InsuranceServiceLogs.InsurerAndRequestId', {
              insurerName: request.insurerName,
              period: request.period,
              requestId: request.requestUID
            })}
          </Box>
        </Typography>
      }
      content={
        <Grid container>
          {request.details.map((detail, index) => {
            return (
              <LogRequestDetailsContainer container key={index}>
                <Grid item xs={12} md={6}>
                  <Card disablePadding>
                    <>
                      <Grid container justifyContent='space-between' alignItems='center'>
                        <Typography fontWeight='bold'>
                          {t('Offer.Edit.InsuranceServiceLogs.RequestDate') + ': ' + formatDate(detail.dateRequestSent)}
                        </Typography>
                        <Grid item>
                          <IconButton
                            id={`Service_Logs_CopyBtn_${index}`}
                            color='primary'
                            size='small'
                            variant='text'
                            tooltip={t('General.CopyToClipboard')}
                            onClick={copyToClipboard(detail.requestContent)}
                          >
                            <AssignmentIcon />
                          </IconButton>
                          <IconButton
                            id={`service_Logs_Request_Content_Download_${index}`}
                            disabled={!detail.requestContent}
                            color='primary'
                            size='small'
                            variant='text'
                            tooltip={t('Tooltips.Download')}
                            onClick={() => onDownloadFile(detail.requestContent, request.requestUID, 'Request', detail.dateRequestSent)}
                          >
                            <CloudDownloadIcon />
                          </IconButton>
                        </Grid>
                      </Grid>
                      <LogMessageContainer item xs={12}>
                        <ExpandingText
                          text={
                            detail.requestContent
                              ? detail.requestContent
                              : t('Offer.Edit.InsuranceServiceLogs.NoResponse', {
                                  insurerName: request.insurerName,
                                  period: request.period
                                })
                          }
                          minLength={300}
                        />
                      </LogMessageContainer>
                    </>
                  </Card>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Card disablePadding>
                    <>
                      <Grid container justifyContent='space-between' alignItems='center'>
                        <Typography fontWeight='bold'>
                          {t('Offer.Edit.InsuranceServiceLogs.ResponseDate') + ': ' + formatDate(detail.dateResponseReceived)}
                        </Typography>
                        <Grid item>
                          <IconButton
                            disabled={!detail.responseContent}
                            id={`Service_Logs_CopyBtn_${index}`}
                            color='primary'
                            size='small'
                            variant='text'
                            tooltip={t('General.CopyToClipboard')}
                            onClick={copyToClipboard(detail.responseContent)}
                          >
                            <AssignmentIcon />
                          </IconButton>
                          <IconButton
                            id={`service_Logs_Response_Content_Download_${index}`}
                            disabled={!detail.responseContent}
                            color='primary'
                            size='small'
                            variant='text'
                            tooltip={t('Tooltips.Download')}
                            onClick={() =>
                              onDownloadFile(detail.responseContent, request.requestUID, 'Response', detail.dateResponseReceived)
                            }
                          >
                            <CloudDownloadIcon />
                          </IconButton>
                        </Grid>
                      </Grid>
                      <LogMessageContainer item xs={12}>
                        <ExpandingText
                          text={
                            detail.responseContent
                              ? detail.responseContent
                              : t('Offer.Edit.InsuranceServiceLogs.NoResponse', {
                                  insurerName: request.insurerName,
                                  period: request.period
                                })
                          }
                          minLength={300}
                        />
                      </LogMessageContainer>
                    </>
                  </Card>
                </Grid>
              </LogRequestDetailsContainer>
            );
          })}
        </Grid>
      }
    />
  );
};

ServiceRequestComponent.propTypes = {
  request: PropTypes.object,
  onDownloadFile: PropTypes.func
};

export default ServiceRequestComponent;
